import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface ChatMessage {
  id: string;
  text: string;
  sender: 'user' | 'ai' | 'system';
  createdAt?: string;
}

interface ChatState {
  chatId: string;
  messages: ChatMessage[];
}

const initialState: ChatState = {
  chatId: crypto.randomUUID(),
  messages: [],
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    addMessage(state, action: PayloadAction<ChatMessage>) {
      state.messages.push(action.payload);
    },
    startNewChat(state) {
      state.chatId = crypto.randomUUID();
      state.messages = [];
    },
  },
});

export const { addMessage, startNewChat } = chatSlice.actions;
export default chatSlice.reducer;
